/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
/* === AYA soldout: рубильник ===
 * 02.09.2026, требование владелицы: «Отключай это, мне нужен мой порядок».
 * Выключены оба блока ниже: демоушен распроданного в разделах и скрытие
 * распроданного на /collections. Витрина показывает ровно тот порядок, который
 * выставлен в админке, распроданное стоит там, где его поставили.
 * Код оставлен на месте: вернуть поведение = поставить true. */
window.AYA_SOLDOUT_ENABLED = false;

/* === AYA soldout-demotion v2 (virtual re-pagination) === */
/*
 * Pushes sold-out product cards OFF the first pages of an enabled collection so
 * shoppers see available products (in the stored MANUAL order) first; sold-out
 * appear only on the last pages. RENDER-TIME ONLY: the stored (Admin) collection
 * order and the server HTML (SEO / no-JS) are never touched — no reorder API is
 * ever called.
 *
 * For virtual page V we render desiredOrder = available(manual) ++ soldout(manual),
 * sliced to V. Cards missing from the current server page are harvested (lazy) from
 * the server page they live on and cached. Page count + nav "showing X-Y of Z" are
 * INVARIANT under an equal-page-size permutation of the same products, so the
 * theme's pagination nav is left completely untouched.
 *
 * Safety: never hides the whole grid (per-card hide only); cooperates with (never
 * replaces) collection-filters-form. Under an active filter/sort we only sink
 * sold-out within the current page (v1 behaviour). Any fetch/parse failure, a
 * manual-order mismatch, or a missing harvested card falls back to the server
 * render — the grid can never be left broken, blank, or holed.
 */
(function () {
  'use strict';
  if (!window.AYA_SOLDOUT_ENABLED) return;

  var DISABLED_COLLECTIONS = []; // runs on ALL collections except any listed here
  var SNAP_TTL = 5 * 60 * 1000; // products.json snapshot freshness (bounds restock latency)
  var FETCH_CAP = 4;

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__ayaSoldoutDemotion) return;

  var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
  var handle = m ? decodeURIComponent(m[1]) : null;
  if (!handle || DISABLED_COLLECTIONS.indexOf(handle) !== -1) return;
  var base = window.location.pathname.slice(0, m.index); // keeps locale prefix

  var state = {
    version: 2, handle: handle, applying: false, gen: 0, revealed: false,
    pageSize: 9, soldout: null, storedOrder: null, desiredOrder: null,
    storedIndex: null, cardPool: {}, pageCached: {}, virtualDisabled: false,
    applies: 0, moves: 0, tiles: null, tileGrid: null
  };
  window.__ayaSoldoutDemotion = state;

  // ---------- helpers ----------
  function gridContainers() { return document.querySelectorAll('[data-products-grid]'); }
  function gridOf(c) { return c.querySelector('.grid') || c; }
  function items(g) { return g.querySelectorAll('[data-grid-item]'); }
  function cardHandle(card) {
    var url = card.getAttribute('data-url') || '';
    if (!url) { var a = card.querySelector('a[href*="/products/"]'); url = a ? (a.getAttribute('href') || '') : ''; }
    var mm = url.match(/\/products\/([^\/?#]+)/);
    return mm ? decodeURIComponent(mm[1]) : null;
  }
  function search() { return window.location.search || ''; }
  function filteredOrSorted() { var s = search(); return s.indexOf('filter.') !== -1 || /[?&]sort_by=/.test(s); }
  function currentPage() { var mm = search().match(/[?&]page=(\d+)/); return mm ? (parseInt(mm[1], 10) || 1) : 1; }
  function idle(fn) { (window.requestIdleCallback ? requestIdleCallback : function (f) { setTimeout(f, 60); })(fn); }

  // ---------- editorial tiles: NOT products, pinned to their server grid slot ----------
  // The owner places featured_image blocks (templates/collection.json, page 1 only) at an ABSOLUTE
  // grid slot: block.settings.position N == Nth child of .grid (verified on the live render —
  // position 3/7 -> children 3/7). They are layout, not inventory, so demotion must never touch
  // them. We snapshot every non-[data-grid-item] child of the primary grid together with its
  // server slot BEFORE anything mutates the DOM, then re-insert at that slot after each pass.
  // SLOT, not neighbour: relative order would anchor a tile to the product it follows, and that
  // product is exactly what demotion moves — the banner would drift a row, or off page 1
  // entirely, whenever something sells out. Pinning the slot keeps the row the owner designed
  // (grid 3-up: tile 3 closes row 1, tile 7 opens row 3) identical no matter which products show.
  // Capture-once + no removals: anything injected later is left alone, never deleted.
  function captureTiles() {
    if (state.tiles) return;
    state.tiles = [];
    var cs = gridContainers(); if (!cs.length) return;
    var grid = gridOf(cs[0]), kids = grid.children;
    state.tileGrid = grid;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].nodeType === 1 && !(kids[i].matches && kids[i].matches('[data-grid-item]'))) {
        state.tiles.push({ node: kids[i], index: i });
      }
    }
  }
  function placeTiles(grid) {
    var t = state.tiles, i;
    if (!t || !t.length || grid !== state.tileGrid) return; // only the grid the tiles came from
    for (i = 0; i < t.length; i++) { if (t[i].node.parentNode === grid) grid.removeChild(t[i].node); }
    for (i = 0; i < t.length; i++) { // ascending slots: re-inserting in order reproduces the server layout
      var idx = t[i].index;
      grid.insertBefore(t[i].node, idx < grid.children.length ? grid.children[idx] : null);
    }
  }

  // ---------- anti-flash: hide only sold-out cards, never the whole grid ----------
  var css = document.createElement('style');
  css.id = 'aya-soldout-antiflicker';
  css.textContent = '[data-grid-item][data-aya-hide]{display:none !important}';
  (document.head || document.documentElement).appendChild(css);
  function reveal() {
    state.revealed = true;
    var hidden = document.querySelectorAll('[data-grid-item][data-aya-hide]');
    for (var i = 0; i < hidden.length; i++) hidden[i].removeAttribute('data-aya-hide');
  }
  setTimeout(reveal, 2000); // failsafe: a hidden card can never persist

  // ---------- availability snapshot (sessionStorage cached, short TTL) ----------
  function loadSnapshot(cb) {
    var key = 'ayaSoldoutSnap:' + handle;
    try {
      var raw = window.sessionStorage.getItem(key);
      if (raw) { var o = JSON.parse(raw); if (o && (Date.now() - o.t) < SNAP_TTL) { cb(o.stored, o.sold); return; } }
    } catch (e) {}
    // paginate products.json (250/page) so collections with >250 products are complete
    var stored = [], sold = {};
    (function fetchPage(pg) {
      fetch(base + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + pg, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          for (var i = 0; i < products.length; i++) {
            var p = products[i]; if (!p.handle) continue; stored.push(p.handle);
            var avail = false, vs = p.variants || [];
            for (var j = 0; j < vs.length; j++) { if (vs[j] && vs[j].available) { avail = true; break; } }
            if (!avail) sold[p.handle] = true;
          }
          if (products.length === 250 && pg < 20) { fetchPage(pg + 1); return; } // more pages (cap 5000)
          try { window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), stored: stored, sold: sold })); } catch (e) {}
          cb(stored, sold);
        })
        .catch(function () { cb(null, null); });
    })(1);
  }

  function buildOrder(stored, sold) {
    state.storedOrder = stored; state.soldout = sold;
    var avail = [], so = [], idx = {};
    for (var i = 0; i < stored.length; i++) { idx[stored[i]] = i; if (sold[stored[i]]) so.push(stored[i]); else avail.push(stored[i]); }
    state.storedIndex = idx;
    state.desiredOrder = avail.concat(so);
  }
  function serverPageOf(h) { return Math.floor(state.storedIndex[h] / state.pageSize) + 1; }

  // ---------- Phase 0: tag + within-page sink (fallback / filtered mode) ----------
  function tagAndSink() {
    if (!state.soldout) return;
    var cs = gridContainers();
    state.applying = true;
    try {
      for (var i = 0; i < cs.length; i++) {
        var g = gridOf(cs[i]), cards = items(g), move = [];
        for (var j = 0; j < cards.length; j++) {
          var h = cardHandle(cards[j]);
          if (h && state.soldout[h]) { cards[j].setAttribute('data-aya-hide', '1'); move.push(cards[j]); }
        }
        if (move.length && move.length < cards.length) { for (var k = 0; k < move.length; k++) g.appendChild(move[k]); state.moves += move.length; }
      }
      if (cs.length) placeTiles(gridOf(cs[0])); // sinking cards shifted the tiles — put them back
    } catch (e) {}
    setTimeout(function () { state.applying = false; }, 0);
  }

  // ---------- harvest missing server pages into cardPool ----------
  function harvestPages(pages, cb) {
    var todo = [], i;
    for (i = 0; i < pages.length; i++) if (!state.pageCached[pages[i]]) todo.push(pages[i]);
    if (!todo.length) { cb(true); return; }
    var inFlight = 0, ptr = 0, ok = true, done = false;
    function finish(res) { if (!done) { done = true; cb(res); } }
    function pump() {
      while (inFlight < FETCH_CAP && ptr < todo.length) {
        var pg = todo[ptr++]; inFlight++;
        (function (pg) {
          fetch(window.location.pathname + '?page=' + pg, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var g = doc.querySelector('[data-products-grid]');
              if (g) {
                var cards = (g.querySelector('.grid') || g).querySelectorAll('[data-grid-item]');
                for (var x = 0; x < cards.length; x++) {
                  var h = cardHandle(cards[x]); if (!h) continue;
                  var imgs = cards[x].querySelectorAll('img');
                  for (var y = 0; y < imgs.length; y++) { imgs[y].setAttribute('loading', 'lazy'); imgs[y].removeAttribute('fetchpriority'); }
                  if (!state.cardPool[h]) state.cardPool[h] = cards[x];
                }
              }
              state.pageCached[pg] = true;
            })
            .catch(function () { ok = false; })
            .then(function () { inFlight--; if (ptr >= todo.length && inFlight === 0) finish(ok); else pump(); });
        })(pg);
      }
    }
    pump();
  }

  // ---------- reconcile the primary grid to desiredOrder slice for current page ----------
  function reconcile(gen) {
    if (gen !== state.gen || !state.desiredOrder) { reveal(); return; }
    var V = currentPage();
    var wanted = state.desiredOrder.slice((V - 1) * state.pageSize, V * state.pageSize);
    var cs = gridContainers(); if (!cs.length || !wanted.length) { reveal(); return; }
    var grid = gridOf(cs[0]);
    var live = {}, cards = items(grid), i;
    for (i = 0; i < cards.length; i++) { var lh = cardHandle(cards[i]); if (lh) live[lh] = cards[i]; }
    var pages = [], need = {};
    for (i = 0; i < wanted.length; i++) { var h = wanted[i]; if (!live[h] && !state.cardPool[h]) { var pg = serverPageOf(h); if (!need[pg]) { need[pg] = true; pages.push(pg); } } }
    harvestPages(pages, function () {
      if (gen !== state.gen) return;
      // abort if any wanted card is still missing -> never render a hole
      for (var a = 0; a < wanted.length; a++) { var hh = wanted[a]; if (!live[hh] && !state.cardPool[hh]) { reveal(); return; } }
      state.applying = true;
      try {
        var wantSet = {}, k;
        for (k = 0; k < wanted.length; k++) {
          var hw = wanted[k]; wantSet[hw] = true;
          var node = live[hw] || state.cardPool[hw].cloneNode(true);
          grid.appendChild(node); // moves existing (keeps node identity) or inserts clone, in wanted order
          node.removeAttribute('data-aya-hide');
        }
        var now = items(grid);
        for (k = now.length - 1; k >= 0; k--) { var hn = cardHandle(now[k]); if (hn && !wantSet[hn]) grid.removeChild(now[k]); }
        placeTiles(grid); // editorial tiles back on their server slots (page 1 only has any)
        state.applies += 1;
      } catch (e) {}
      setTimeout(function () { state.applying = false; }, 0);
      reveal();
    });
  }

  // ---------- per-render orchestration ----------
  function render() {
    state.gen += 1; var gen = state.gen;
    if (!state.soldout) { reveal(); return; }
    tagAndSink(); // Phase 0: hide sold-out flash + worst-case sink to page bottom
    if (state.virtualDisabled || filteredOrSorted()) { reveal(); return; } // within-page mode
    idle(function () { reconcile(gen); }); // virtual mode (default view only), off the LCP path
  }

  function watch() {
    if (!window.MutationObserver) return;
    var cs = gridContainers(); if (!cs.length) return;
    var timer = null;
    var mo = new MutationObserver(function (records) {
      if (state.applying) return;
      var relevant = false;
      for (var i = 0; i < records.length && !relevant; i++) { var ad = records[i].addedNodes; for (var j = 0; j < ad.length; j++) { if (ad[j].nodeType === 1) { relevant = true; break; } } }
      if (!relevant) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(render, 120);
    });
    for (var i = 0; i < cs.length; i++) mo.observe(cs[i], { childList: true, subtree: true });
    state.observer = mo;
  }

  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  // ---------- calibration: page size + manual-order self-check (runs on EVERY page) ----------
  // pageSize must equal the theme's products_per_page (this theme renders 9 per page; idr 10).
  // A wrong value mis-slices desiredOrder and can repeat a card across two virtual pages, so it is
  // never assumed: page 1 gives it directly, and on page V>1 the server slice yields it — the first
  // server-rendered card sits at (V-1)*pageSize of the stored manual order. Anything that does not
  // line up (unknown handle, non-integer size, order mismatch) -> within-page fallback.
  function calibrate() {
    var cs = gridContainers(); if (!cs.length) { state.virtualDisabled = true; return; }
    var cards = items(gridOf(cs[0])), hs = [], i, h;
    for (i = 0; i < cards.length; i++) { h = cardHandle(cards[i]); if (!h) { state.virtualDisabled = true; return; } hs.push(h); }
    var V = currentPage(), first = hs.length ? state.storedIndex[hs[0]] : undefined;
    if (first === undefined) { state.virtualDisabled = true; return; }
    var ps = (V === 1) ? (first === 0 ? hs.length : 0)
                       : ((first > 0 && first % (V - 1) === 0) ? first / (V - 1) : 0);
    if (!ps || ps < hs.length) { state.virtualDisabled = true; return; }
    state.pageSize = ps;
    // manual-order self-check: this server page must be storedOrder[first .. first + n)
    for (i = 0; i < hs.length; i++) { if (hs[i] !== state.storedOrder[first + i]) { state.virtualDisabled = true; break; } }
    if (state.virtualDisabled && window.console) console.warn('[aya-soldout] products.json not in manual order -> within-page fallback');
  }

  // ---------- init ----------
  loadSnapshot(function (stored, sold) {
    if (!stored) { reveal(); return; } // availability unknown -> leave the server render
    buildOrder(stored, sold);
    onReady(function () {
      try { captureTiles(); } catch (e) { state.tiles = []; } // BEFORE any DOM mutation
      try { if (!filteredOrSorted()) calibrate(); } catch (e) { state.virtualDisabled = true; }
      render();
      watch();
    });
  });
})();
/* === /AYA soldout-demotion === */

/* === AYA soldout-sink (collections index only) === */
/*
 * On the /collections INDEX page (list of collections with featured product rows), HIDE
 * sold-out cards entirely. Those rows show only a few items, so demoting to the end still
 * leaves sold-out on screen — the owner wants them gone from the list. DOM-detected via the
 * sold-out badge (.sold-box). Render-time only; SCOPED to the index (never product pages, a
 * specific collection, or home); fails open.
 */
(function () {
  'use strict';
  if (!window.AYA_SOLDOUT_ENABLED) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__ayaSoldoutSink) return;
  // ONLY the collections index (path ends in /collections). Never /products/, /collections/{handle}, or home.
  var path = window.location.pathname.replace(/\/+$/, '');
  if (!/\/collections$/.test(path)) return;
  var state = { applying: false };
  window.__ayaSoldoutSink = state;

  function isSold(card) {
    if (card.querySelector('.sold-box, .badge-box.sold-box')) return true;
    var b = card.querySelector('.badge_text');
    return !!(b && /sold\s*out/i.test(b.textContent || ''));
  }
  function hideSold() {
    if (state.applying) return;
    var cards = document.querySelectorAll('[data-grid-item]');
    if (!cards.length) return;
    state.applying = true;
    try { for (var i = 0; i < cards.length; i++) { if (isSold(cards[i])) cards[i].style.setProperty('display', 'none', 'important'); } }
    catch (e) {}
    setTimeout(function () { state.applying = false; }, 0);
  }
  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  onReady(function () {
    hideSold();
    if (!window.MutationObserver) return;
    var t = null, mo = new MutationObserver(function () { if (state.applying) return; if (t) clearTimeout(t); t = setTimeout(hideSold, 150); });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
/* === /AYA soldout-sink === */

/* === AYA: живая ссылка на инстаграм ===
 * 02.09.2026, требование владелицы: «@AYA_SACREDWEAR должна быть живая кнопка,
 * по которой сразу попадаешь в инстаграм».
 * Текст набран в редакторе темы как обычный заголовок, ссылки там нет и
 * добавить её в настройках нельзя. Оборачиваем сам текст в <a>, ничего не
 * переписывая: если владелица поменяет надпись, скрипт просто не сработает.
 * Откат: удалить блок. */
(function () {
  'use strict';
  var URL_IG = 'https://www.instagram.com/aya_sacredwear/';
  /* Собачка обязательна: в футере отдельно стоит заголовок «AYA SACRED WEAR» —
     это название бренда, а не аккаунт, ссылкой он становиться не должен. */
  var RE = /^@\s*aya[_.-]?sacredwear\s*$/i;

  function linkify(root) {
    var nodes = (root || document).querySelectorAll(
      'h1,h2,h3,h4,p,span,div.hero__title,.hero__subheading');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;
      if (el.closest('a')) continue;
      if (el.getAttribute('data-aya-ig')) continue;
      var txt = (el.textContent || '').trim();
      if (!RE.test(txt)) continue;
      var a = document.createElement('a');
      a.href = URL_IG;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', 'Instagram AYA Sacred Wear');
      a.style.color = 'inherit';
      a.style.textDecoration = 'none';
      a.textContent = txt;
      el.setAttribute('data-aya-ig', '1');
      el.textContent = '';
      el.appendChild(a);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    linkify(document);
    if (!window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () { linkify(document); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
/* === /AYA инстаграм-ссылка === */

/* === AYA: _fbp/_fbc из куки в атрибуты корзины (15.09.2026, v2 от 17.09.2026) ===
 *
 * Зачем. Серверный Purchase (app/Services/MetaConversionsApi.php) отправляет Meta всё, что
 * есть в вебхуке заказа, но два самых сильных ключа сопоставления туда не попадают никогда:
 * `_fbp` (идентификатор браузера) и `_fbc` (идентификатор клика по рекламе) живут в куках
 * первой стороны и на сервер сами не уходят. Мост — атрибут корзины: Shopify переносит
 * атрибуты корзины в заказ как note_attributes, а вебхук отдаёт их нам.
 *
 * Покупатель не видит ничего. Имена начинаются с подчёркивания, а такие атрибуты Shopify
 * считает приватными: их нет ни в корзине, ни в чекауте, ни в письмах.
 *
 * Три предохранителя, каждый по делу:
 *   1. пустую корзину не трогаем вовсе — запись в неё создаёт cart-токен и рисует в
 *      аналитике корзины, которых покупатель не создавал;
 *   2. если атрибут уже стоит и совпадает — второй записи нет, чтобы не дёргать /cart/update.js
 *      на каждой странице;
 *   3. клик по «Checkout» синхронизирует ещё раз с keepalive: покупатель, который добавил
 *      товар и сразу ушёл в чекаут из выезжающей корзины, иначе уехал бы без атрибута,
 *      а переход отменил бы обычный fetch.
 *
 * ПОЧЕМУ У КЛИКА ОТДЕЛЬНЫЙ ПУТЬ (17.09.2026, после заказа #12062)
 * Первая версия и на клике сначала ЧИТАЛА /cart.js и писала только в ответе. Замер
 * (`qa/hdd_fbcart.py`, пятая проба): запись уходила через 142 мс после клика на быстром
 * канале, и все эти миллисекунды её отменял переход в чекаут — `keepalive` защищал
 * запрос, который ещё не был отправлен. На мобильном канале круговой ход — сотни мс,
 * то есть терялся не край случаев, а обычный путь «положил и сразу в чекаут».
 * Поэтому на клике запись уходит ПЕРВЫМ же запросом, без чтения. Предохранитель 1 при
 * этом цел: пишем только когда есть кука `cart`, то есть корзина уже существует и
 * cart-токен не создаётся нами. Нет куки — падаем на старый путь с чтением, он
 * безопасен по построению. Цена: на клике возможна одна лишняя запись, если атрибут
 * уже стоял. Одна запись на чекаут против потерянного ключа сопоставления.
 *
 * Витрина не должна падать из-за метрики: всё в try/catch и .catch(), ошибок наружу нет.
 * Откат: удалить блок целиком, бэкап рядом в backups/theme/eco/.
 */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;   // в редакторе темы не работаем
  if (window.__ayaFbCart) return;
  window.__ayaFbCart = true;

  function cookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function sync(keepalive) {
    var fbp = cookie('_fbp');
    var fbc = cookie('_fbc');
    if (!fbp && !fbc) return;                                 // нечего передавать
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.item_count) return;                // предохранитель 1
        var have = cart.attributes || {};
        var need = {};
        if (fbp && have._fbp !== fbp) need._fbp = fbp;
        if (fbc && have._fbc !== fbc) need._fbc = fbc;
        if (!Object.keys(need).length) return;                // предохранитель 2
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          keepalive: !!keepalive,                             // предохранитель 3
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: need })
        });
      })
      .catch(function () {});
  }

  function syncFast() {
    // Запись ПЕРВЫМ запросом: ничего не читаем, потому что читать уже некогда.
    var fbp = cookie('_fbp');
    var fbc = cookie('_fbc');
    if (!fbp && !fbc) return false;
    if (!cookie('cart')) return false;                        // корзины нет — не плодим токен
    var need = {};
    if (fbp) need._fbp = fbp;
    if (fbc) need._fbc = fbc;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: need })
      }).catch(function () {});
    } catch (e) { return false; }
    return true;
  }

  // Пиксель ставит _fbp не мгновенно — даём ему секунды, потом синхронизируем.
  setTimeout(function () { sync(false); }, 2500);

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('[name="checkout"], a[href*="/checkout"], button[href*="/checkout"]')
      : null;
    if (el && !syncFast()) sync(true);
  }, true);
})();
/* === /AYA _fbp/_fbc в корзину === */
